import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { ThhHundActions } from '../thhHundActions';

export interface Vorbelegungen {
  adresseImmobilieVorbelegt: boolean;
  versicherungsnehmerVorbelegt: boolean;
}

export const vorbelegungenReducer = function (
  sectionState: Vorbelegungen = null,
  action: AnyAction,
): Vorbelegungen {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return {
        ...sectionState,
        versicherungsnehmerVorbelegt: true,
        adresseImmobilieVorbelegt: true,
      };
    }
    case ThhHundActions.PLZ_CHANGED: {
      return {
        ...sectionState,
        adresseImmobilieVorbelegt: false,
      };
    }
    default:
      return sectionState;
  }
};
